const giftreggieFront = document.querySelector('.giftreggie-front');

if (
  giftreggieFront.querySelector('.shipping-form') &&
  giftreggieFront.querySelector('.enter-btn')
) {
  const addressForm = giftreggieFront.querySelector('.shipping-form');
  giftreggieFront
    .querySelector('.enter-btn')
    .addEventListener('click', (event) => {
      event.preventDefault();
      if (addressForm.style.display === 'none') {
        addressForm.style.display = 'block';
      } else {
        addressForm.style.display = 'none';
      }
    });
}

if (
  giftreggieFront.classList.contains('giftreggie-manager') ||
  giftreggieFront.classList.contains('giftreggie-guest')
)
  moveRegistryTitle();

function moveRegistryTitle() {
  if (!giftreggieFront.querySelector('.giftreggie-header')) return;

  if (!giftreggieFront.querySelector('.giftreggie-registry-title')) return;

  giftreggieFront
    .querySelector('.giftreggie-header')
    .appendChild(giftreggieFront.querySelector('.giftreggie-registry-title'));
}
